import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook-color",
  "use": "icon-facebook-color-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-facebook-color\">\n<path d=\"M19 10.0548C19 5.05274 14.9718 1 10 1C5.02823 1 1 5.05274 1 10.0548C1 14.5741 4.29117 18.3202 8.59375 19V12.6723H6.30746V10.0548H8.59375V8.0598C8.59375 5.79063 9.93649 4.5372 11.9931 4.5372C12.978 4.5372 14.0079 4.71391 14.0079 4.71391V6.9411H12.8727C11.755 6.9411 11.4062 7.63919 11.4062 8.35517V10.0548H13.9023L13.5031 12.6723H11.4062V19C15.7088 18.3202 19 14.5741 19 10.0548Z\" fill=\"#4267B2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/facebook-color.svg
// module id = lAUE
// module chunks = 258